import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { useSelector } from "react-redux";

export default function ClientEset() {

    const { data: esetDevices = [], esetDevicesLoading, esetDevicesError } = useSelector((state) => state.eset.devices);
    const { data: esetLicenses = [], esetLicensesLoading, esetLicensesError } = useSelector((state) => state.eset.licenses);
    
    console.log(esetDevices)


  return (
    <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
            <CardContent>
              <Typography variant="h6">Votre protection antivirus</Typography>
              {esetLicensesLoading ? (
                <Typography variant="body2">Chargement...</Typography>
              ) : esetLicensesError ? (
                <Typography variant="body2" color="error">Erreur de chargement</Typography>
              ) : (
                <Typography variant="body2">
                {esetLicenses.length > 0
                  ? esetLicenses.map((lic, idx) => lic.name || lic.nom || "Antivirus inconnu").join(", ")
                  : "Aucune licence trouvée."}
                </Typography>
              )}
            </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
            <CardContent>
              <Typography variant="h6">Appareils protégés</Typography>
              {esetDevicesLoading ? (
                <Typography variant="body2">Chargement...</Typography>
              ) : esetDevicesError ? (
                <Typography variant="body2" color="error">Erreur de chargement</Typography>
              ) : (
                <Typography variant="body2">
                {esetDevices.length} appareil{esetDevices.length > 1 ? "s" : ""} sécurisé{esetDevices.length > 1 ? "s" : ""}.
                </Typography>
              )}
            </CardContent>
            </Card>
          </Grid>
        </Grid>
    </Box>
    // <Grid container spacing={2}>
    //   <Grid item xs={12} md={6}>
    //     <Card>
    //       <CardContent>
    //         <Typography variant="h6">Licences Antivirus</Typography>
    //         <Typography variant="body2">12 licences actives.</Typography>
    //       </CardContent>
    //     </Card>
    //   </Grid>
    //   <Grid item xs={12} md={6}>
    //     <Card>
    //       <CardContent>
    //         <Typography variant="h6">Appareils protégés</Typography>
    //         <Typography variant="body2">10 appareils sécurisés.</Typography>
    //       </CardContent>
    //     </Card>
    //   </Grid>
    // </Grid>
  );
}
